'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _quiverAssets = require('@surfline/quiver-assets');

var _quiverAssets2 = _interopRequireDefault(_quiverAssets);

var _base = require('./translations/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = function (_Component) {
  (0, _inherits3.default)(NotFound, _Component);

  function NotFound(props) {
    (0, _classCallCheck3.default)(this, NotFound);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).call(this, props));

    _this.onClickHandler = _this.onClickHandler.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(NotFound, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.analytics) {
        window.analytics.page('Error', '500');
      }
    }
  }, {
    key: 'onClickHandler',
    value: function onClickHandler() {
      if (window.analytics) {
        window.analytics.track('error_page_500_clicked_homepage');
      }
      location.replace('/');
    }

    /* eslint-disable max-len */

  }, {
    key: 'render',
    value: function render() {
      var image = _quiverAssets2.default + '/backgrounds/500-mobile-image.jpg';

      return _react2.default.createElement(
        'div',
        { className: 'body__500' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'h5',
            { className: 'container__subheading' },
            _base2.default.five_hundred.subheading
          ),
          _react2.default.createElement(
            'p',
            { className: 'container__paragraph' },
            _base2.default.five_hundred.paragraph_top
          ),
          _react2.default.createElement(
            'p',
            { className: 'container__paragraph__desktop' },
            _base2.default.five_hundred.paragraph_bottom_before,
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'a',
                { onClick: this.onClickHandler, className: 'container__paragraph__link' },
                _base2.default.five_hundred.paragraph_bottom_link
              )
            ),
            _base2.default.five_hundred.paragraph_bottom_after
          ),
          _react2.default.createElement(
            'button',
            { onClick: this.onClickHandler, className: 'quiver-button' },
            _base2.default.five_hundred.button_text
          ),
          _react2.default.createElement(
            'div',
            { className: 'container_image_container' },
            _react2.default.createElement('img', { className: 'container_image', src: image, alt: '500 Error' })
          )
        )
      );
    }
  }]);
  return NotFound;
}(_react.Component);

exports.default = NotFound;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflineErrors/FiveHundred.js
// module id = 665
// module chunks = 11